import store from '@/store'

/**
 * Process types whose steps are rendered by the config driven ProcessFlow under one single
 * `${type}Steps` route: their step travels as a query param instead of as a path segment.
 * Every other type gets a route per step (`${type}Step${n}`, step as path param).
 *
 * Mirrors the routes registered in App.vue's addProcessStepsToRouter().
 */
const FORM_GENERATED_TYPES = ['private', 'brussels', 'wallonia', 'takeover']

/**
 * The step a process should be opened on.
 *  `processStatus.currentStep === 100` is the 'completed' sentinel: those open on the last
 *  configured step of their type.
 */
export function resolveCurrentStep({ processType, currentStep }) {
  if (currentStep !== 100) return currentStep || 1

  const steps = store.getters['tenant/getProcessesConfig']?.[processType]?.steps
  return steps?.at(-1)?.step || currentStep
}

/**
 * The router target that opens a process on the step it is actually at.
 *
 * Callers that only know a process' uuid (a map marker popup, for instance) have to look the
 * process up first: the step is part of the route, so it cannot be derived from the uuid.
 * Passing no step at all is not an alternative — the views only restore it from the process
 * that is currently selected, which is still the previous one while navigating.
 */
export function processRouteTo({ uuid, processType, currentStep }) {
  const type = processType?.value
  const step = resolveCurrentStep({ processType: type, currentStep })
  const isFormGenerated = FORM_GENERATED_TYPES.includes(type)

  return {
    name: isFormGenerated ? `${type}Steps` : `${type}Step${step}`,
    params: {
      uuid,
      type: processType?.routeType,
      ...(isFormGenerated ? {} : { step })
    },
    ...(isFormGenerated ? { query: { step } } : {})
  }
}
